import { decode as base64Decode } from 'base-64';

import { fromJSON } from '../object/object';

export const decode = (token) => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace('-', '+').replace('_', '/');
    return fromJSON(base64Decode(base64));
  } catch (error) {
    return null;
  }
};
